import { DataBean } from "../DataBean";

export class RequestMaintenanceImplements extends DataBean {

  public async getRequestMaintenanceImplementsCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getRequestMaintenanceImplementsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getRequestMaintenanceImplementsRender( page: number, row: number, props: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getRequestMaintenanceImplementsRender_Number_Number_java.util.Map",
      [page, row, props]
    );
  }

  public async deleteRequestMaintenanceImplements(idrequestmaintenanceimplements: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteRequestMaintenanceImplements_Number", [idrequestmaintenanceimplements]);
  }

  public async updateRequestMaintenanceImplements(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.RequestMaintenanceImplements_updateRequestMaintenanceImplements_com.orange.finance.processcontract.bean.RequestMaintenanceImplements",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.RequestMaintenanceImplements",
        },
      ]
    );
  }
}
